import loadable from '@loadable/component';

export const FourfourtwoSiteWrapper = loadable(
  () => import(/* webpackChunkName: "fourfourtwo-site" */ './FourfourtwoSiteWrapper'),
);
